import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../services';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { DemurrageDetentionSearchCriteria } from '../models/shipment.model';
import {
  DemurrageDetentionListDto,
  DemurrageDetentionStatisticFiltersModel,
} from '../models/demurrage-detention/demurrage-detention-list.model';
import { ShipmentEndpoint } from '../constants';
import { Observable } from 'rxjs';
import {
  DemurrageDetentionStatisticFilterModel,
  ShipmentFiltersDatepickerRangeOutput,
} from '../models/shipment-filters.model';
import { convertDateRangesToWallClockUTC } from '../../../../../common';

@Injectable({
  providedIn: 'root',
})
export class DemurrageDetentionListService {
  constructor(private http: WrapperHttpService) {}

  getList({
    size,
    page,
    dndStatisticFilter,
    filters,
  }: DemurrageDetentionSearchCriteria): Observable<DemurrageDetentionListDto> {
    const url = `${API_URL}${ShipmentEndpoint.Base}${ShipmentEndpoint.ContainerCharges}`;
    return this.http.withLoading().post<DemurrageDetentionListDto>(url, {
      statisticFilter: dndStatisticFilter,
      size,
      page,
      filter: convertDateRangesToWallClockUTC(filters),
    });
  }

  getStatistics({
    size,
    page,
    dndStatisticFilter,
    filters,
  }: DemurrageDetentionSearchCriteria): Observable<DemurrageDetentionStatisticFiltersModel> {
    const url = `${API_URL}${ShipmentEndpoint.Base}${ShipmentEndpoint.ContainerCharges}${ShipmentEndpoint.Statistics}`;

    return this.http.post<DemurrageDetentionStatisticFiltersModel>(url, {
      statisticFilter: dndStatisticFilter,
      size,
      page,
      filter: convertDateRangesToWallClockUTC(filters),
    });
  }

  startExportToFile(body: {
    reportName: string;
    searchRequestView: {
      filter: ShipmentFiltersDatepickerRangeOutput;
      statisticFilter: DemurrageDetentionStatisticFilterModel;
    };
  }): Observable<void> {
    const url = `${API_URL}${ShipmentEndpoint.Shipment}${ShipmentEndpoint.ContainerCharges}${ShipmentEndpoint.Exports}`;

    return this.http.withLoading().post<void>(url, {
      ...body,
      searchRequestView: {
        ...body.searchRequestView,
        filter: convertDateRangesToWallClockUTC(body.searchRequestView.filter),
      },
    });
  }
}
